import { Link, useLocation } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { navFor } from './nav.js';

export function Breadcrumbs({ extra }: { extra?: string }) {
  const { pathname } = useLocation();
  const hit = navFor(pathname);
  if (!hit) return null;
  const deeper = pathname !== hit.item.path;
  return (
    <nav aria-label="Breadcrumb" className="hidden min-w-0 items-center gap-1.5 text-sm text-muted-foreground md:flex">
      <span>{hit.group.label}</span>
      <ChevronRight className="h-3.5 w-3.5" aria-hidden />
      {deeper ? <Link to={hit.item.path} className="hover:text-foreground">{hit.item.label}</Link>
        : <span className="font-medium text-foreground" aria-current="page">{hit.item.label}</span>}
      {deeper && (
        <>
          <ChevronRight className="h-3.5 w-3.5" aria-hidden />
          <span className="truncate font-medium text-foreground" aria-current="page">{extra ?? 'Details'}</span>
        </>
      )}
    </nav>
  );
}
